import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { DatePicker, Icon, IconButton, MultiLineTextField, TextField, Autocomplete, Checkbox, Chip, FormControl, ListItemText, MenuItem } from '@frontend-workspace/react-shared-lib';
import { useGetRequestNewHook } from '../../../requestUtils';
import { useState } from 'react';
import { GetCurrentCompany } from '../../../customer-context/customer-context';
import { getPlainDate, useSalesOfferContext } from '@frontend-workspace/webkua-lib';
import { ICompanySOUserAccounts } from '../../../_models/company-user-accounts';
import { ContractDetailsDialog } from '../../sales-offer-dialogs/sales-offer-dialogs';

interface SalesOfferDetailsProps { }

const SalesOfferDetails = (props: SalesOfferDetailsProps) => {
  const { t } = useTranslation();
  const currentCompany = GetCurrentCompany();
  const { formData, updateFormData } = useSalesOfferContext();
  const [contractDetailsDialogVisible, setContractDetailsDialogVisible] = useState(false);
  //const { data: personsInCompany }: { data: ICompanySOUserAccounts[] } = useGetRequestNewHook(`companies/${formData.companyNumber}/superofficePersons`, [], []);

  // const personOptions = personsInCompany
  //   .filter((p) => !!p.email)
  //   .map((p) => ({
  //     id: `${p.email}`, // Ensure unique ID
  //     label: `${p.firstName} ${p.lastName} (${p.email}) ${p.title ? `(${p.title})` : ''}`,
  //     email: p.email,
  //   }));

  // const selectedPersonIds = personOptions.filter((o) => formData.customerEmails.includes(o.email)).map((o) => o.id)

  // const handlePersonChange = (personId: string) => {
  //   const updatedPersonIds = selectedPersonIds.includes(personId)
  //     ? selectedPersonIds.filter((id) => id !== personId)
  //     : [...selectedPersonIds, personId];

  //   updateFormData(
  //     'customerEmails',
  //     updatedPersonIds.map((id) => personOptions.find((p) => p.id === id)?.email || '')
  //   );
  // };

  return (
    <>
      <Row>
        <Col md={12} xxl={6}>
          <Row>
            <Col sm={6} xxl={3}>
              <div className='mb-3'>
                <DatePicker
                  inputFormat="dd.MM.yyyy"
                  label={t('standard.validUntil')}
                  value={formData.expirationDate}
                  onChange={(date) => updateFormData('expirationDate', date)}
                />
              </div>
            </Col>
            <Col sm={6} xxl={3}>
              <div className='mb-3'>
                <TextField
                  label={t('shop.renewalDate')}
                  name='renewalDate'
                  fullWidth
                  disabled
                  value={getPlainDate(formData.contract?.renewalDate, t) || ''}
                />
              </div>
            </Col>
            <Col sm={6} xxl={3}>
              <div className='mb-3'>
                <TextField
                  label={t('standard.offerNo')}
                  name='offerNumber'
                  fullWidth
                  disabled
                  value={formData.proposalNumber || ""}
                />
              </div>
            </Col>
            <Col sm={6} xxl={3}>
              <div className='d-flex align-items-end mb-3'>
                <TextField
                  label={t('standard.contractNo')}
                  name='contractNumber'
                  fullWidth
                  disabled
                  value={formData.contract?.contractNumber || ""}
                />
                <IconButton
                  size='small'
                  color='info'
                  onClick={() => setContractDetailsDialogVisible(true)}
                  disabled={!formData.contract}
                  className='ms-1' >
                  <Icon className='material-icons-outlined'>info</Icon>
                </IconButton>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className='mb-3'>
                <TextField
                  label={t('standard.seller')}
                  name='seller'
                  fullWidth
                  disabled
                  value={formData.salesAgent.name || ""}
                />
              </div>
            </Col>
          </Row>
          <div className='mb-3'>
            <MultiLineTextField
              value={formData.internalNote || ""}
              onChange={(e) => updateFormData('internalNote', e.target.value)}
              label={t("standard.internalNote")}
              rows={3}
              fullWidth
            />
          </div>
        </Col>

        <Col md={12} xxl={6}>
          <Row>
            <Col md={8}>
              <div className='mb-3'>
                <TextField
                  label={t('standard.customer')}
                  name='customer'
                  fullWidth
                  disabled
                  value={`${currentCompany?.name || ""} ${currentCompany?.department || ""}`}
                />
              </div>
            </Col>
            <Col md={4}>
              <div className='mb-3'>
                <TextField
                  label={t('standard.companyNo')}
                  name='companyNumber'
                  fullWidth
                  disabled
                  value={currentCompany?.number || ""}
                />
              </div>
            </Col>
          </Row>
          {/* <Row>
            <Col>
              <FormControl className='mb-3' fullWidth>
                <Autocomplete
                  multiple
                  limitTags={1}
                  value={selectedPersonIds}
                  options={personOptions.map((o) => o.id)}
                  getOptionLabel={(id) =>
                    personOptions.find((option) => option.id === id)?.label || ''
                  }
                  renderTags={(value, getTagProps) => (
                    <>
                      {value.slice(0, 1).map((id, index) => (
                        <Chip
                          {...getTagProps({ index })}
                          key={id}
                          label={
                            personOptions.find((option) => option.id === id)?.label || ''
                          }
                        />
                      ))}
                      {value.length > 1 && ` +${value.length - 1}`}
                    </>
                  )}
                  renderInput={(params: any) => (
                    <TextField {...params} label={t("standard.recipientOfOffer")} fullWidth />
                  )}
                  filterOptions={(options, state: any) =>
                    options.filter((id) =>
                      personOptions
                        .find((option) => option.id === id)
                        ?.label.toLowerCase()
                        .includes(state.inputValue.toLowerCase())
                    )
                  }
                  renderOption={(props: any, id: any) => (
                    <MenuItem key={id} value={id}>
                      <Checkbox
                        checked={selectedPersonIds.includes(id)}
                        onChange={() => handlePersonChange(id)}
                      />
                      <ListItemText
                        primary={
                          personOptions.find((option) => option.id === id)?.label || ''
                        }
                      />
                    </MenuItem>
                  )}
                  onChange={(event, ids) => {
                    updateFormData(
                      'customerEmails',
                      ids.map((id: any) => personOptions.find((p) => p.id === id)?.email || '')
                    );
                  }}
                />
              </FormControl>
            </Col>
          </Row> */}
          <div className='mb-3'>
            <MultiLineTextField
              value={formData.noteToCustomer || ""}
              onChange={(e) => updateFormData('noteToCustomer', e.target.value)}
              label={t("standard.noteToCustomer")}
              rows={3}
              fullWidth
            />
          </div>
        </Col>
      </Row>

      {formData.contract &&
        <ContractDetailsDialog
          open={contractDetailsDialogVisible}
          onClose={() => setContractDetailsDialogVisible(false)}
          contract={formData.contract}
        />
      }
    </>);
};

export default SalesOfferDetails;
